var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.0088,
    cy: 25.0088,
    r: 25,
    transform: "rotate(-0.0202095 25.0088 25.0088)",
    fill: "url(#paint0_linear_11_69)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.984 29.016H22.792L22.12 31H19.256L23.32 19.768H26.488L30.552 31H27.656L26.984 29.016ZM26.28 26.904L24.888 22.792L23.512 26.904H26.28Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11_69",
    x1: 25.0088,
    y1: 0.00881958,
    x2: 25.0088,
    y2: 50.0088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEB244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE9A31"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.47d8e2f15241616525976349811b9908.svg";
export { ForwardRef as ReactComponent };